<template>
  <FixedLoader v-if="loading" />
  <LayoutCenter v-if="!loading && data">
    <p class="text-basic text-center font-serif text-2xl leading-normal">
      <BlockContent :blocks="data.content" />
    </p>
    <template #footer>
      <div class="text-basic text-center tracking-wider">
        <BlockContent :blocks="data.footer" />
      </div>
    </template>
  </LayoutCenter>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import getAbout from '@/sanity/requests/about';
import LayoutCenter from '@/components/LayoutCenter.vue';
import { setMeta } from '@/store';

export default defineComponent({
  name: 'About',
  components: {
    LayoutCenter,
  },
  setup() {
    setMeta({ title: 'About' });
    return { ...getAbout() };
  },
});
</script>
